import { CopyOutlined } from '@ant-design/icons';
import { Category, Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { copyDocument, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { useAppDispatch } from 'utilities/hooks';
import { useEffect } from 'react';
import { setExcluded } from 'slices/categoriesSlice';
import { MenuItemType } from 'antd/es/menu/interface';

export const Copy = (
    row: Category | Document,
    fetchData: () => void
): MenuItemType => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();
    const copyItem = async (destination: Category | null) => {
        await dispatch(copyDocument({
            id: (row as Document).id,
            category_id: destination?.id || null,
        }));

        dispatch(refreshDocumentTreeLevels([destination?.id]));
        fetchData();
    };

    return {
        key: 'Copy',
        label: 'Copy',
        onClick: () => {
            openModal('categoriesTreeModal', {
                title: 'Copy to...',
                submitLabel: 'Copy',
                cancelLabel: 'Cancel',
            }, {
                onSubmit: (value: Category|null) => {
                    copyItem(value);
                }
            });
        },
        icon: <CopyOutlined />,
    };
}